import React from 'react'
import { t } from 'ttag'
import isFunction from 'lodash/isFunction'

import round1Active from '@h2/assets/svg/icons/round1Active.svg'
import round1Inactive from '@h2/assets/svg/icons/round1Inactive.svg'
import round2Active from '@h2/assets/svg/icons/round2Active.svg'
import round2Inactive from '@h2/assets/svg/icons/round2Inactive.svg'
import round3Active from '@h2/assets/svg/icons/round3Active.svg'
import round3Inactive from '@h2/assets/svg/icons/round3Inactive.svg'
import round4Active from '@h2/assets/svg/icons/round4Active.svg'
import round4Inactive from '@h2/assets/svg/icons/round4Inactive.svg'
import round5Active from '@h2/assets/svg/icons/round5Active.svg'
import round5Inactive from '@h2/assets/svg/icons/round5Inactive.svg'
import round6Active from '@h2/assets/svg/icons/round6Active.svg'
import round6Inactive from '@h2/assets/svg/icons/round6Inactive.svg'

export class NumericStepper extends React.PureComponent {
  constructor(props) {
    super(props)
    //console.log("In stepper constructor")
    this.state = {
      step: 0,
      numSteps: React.Children.count(props.children)
    }
    this.genSteps.bind(this)
  }

  genSteps() {
    //console.log("Gen Steps", this.state)
    const currentStep = this.props.activeStep
    const steps = []
    const currState = this.state
    const myThis = this
    const linear = this.props.linear

    this.props.children.forEach(function (child, i) {
      //console.log("Iterating")
      if (!child.type) {
        return null
      }

      switch (child.type.name) {
        case 'Step':
        default:
          /*
           *   console.log(child.type, currentStep, child.props.active, child);
           * console.log(i, currentStep, i == currentStep)
           */
          steps.push(
            <div
              style={{ width: `${100 / currState.numSteps}%`, float: 'left' }}
              className={i == currentStep ? 'active' : 'inactive'}
              key={`step-${i}`}>
              {React.cloneElement(child, {
                stepInStepper: i,
                active: i == currentStep,
                allowArbitrarySelection: !linear,
                completed: (linear && i < currentStep) || child.props.completed
              })}
            </div>
          )
      }
    })

    return steps
  }

  render() {
    return (
      <div>
        <div
          className="row step-wrapper"
          style={{
            border: '1px solid #ddd',
            borderRadius: '25px',
            backgroundColor: '#fdfdfd',
            padding: '7px',
            marginBottom: '35px'
          }}>
          {this.genSteps()}
        </div>
      </div>
    )
  }
}

export const StepButton = props => {
  return <span>{props.children}</span>
}

export const Step = props => {
  //console.log(props)
  const genImage = (round, isActive) => {
    switch (round) {
      case 0:
        return isActive ? round1Active : round1Inactive
      case 1:
        return isActive ? round2Active : round2Inactive
      case 2:
        return isActive ? round3Active : round3Inactive
      case 3:
        return isActive ? round4Active : round4Inactive
      case 4:
        return isActive ? round5Active : round5Inactive
      case 5:
        return isActive ? round6Active : round6Inactive

      default:
        return ''
    }
  }

  return (
    <a
      className="step-link"
      onClick={() => {
        if (
          (props.allowArbitrarySelection || props.completed || props.active) &&
          props.onClick &&
          isFunction(props.onClick)
        ) {
          props.onClick()
        }
      }}>
      <img
        alt={t`Step ${props.stepInStepper}`}
        style={{
          maxHeight: '40px',
          maxWidth: '40px',
          verticalAlign: 'middle',
          transition: 'all .3s ease-in-out',
          filter: !props.active && props.completed ? 'invert(.2)' : 'none',
          transform: props.active ? 'scale(1.1)' : 'scale(1)'
        }}
        src={genImage(props.stepInStepper, props.completed || props.active)}
      />{' '}
      <span className="step-name">{props.children}</span>
    </a>
  )
}

export class InternalNumericStepper extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
      numSteps: React.Children.count(this.props.children)
    }
  }

  genImage(round, currentStep) {
    switch (round) {
      case 0:
        return round === currentStep ? round1Active : round1Inactive
      case 1:
        return round === currentStep ? round2Active : round2Inactive
      case 2:
        return round === currentStep ? round3Active : round3Inactive
      case 3:
        return round === currentStep ? round4Active : round4Inactive
      case 4:
        return round === currentStep ? round5Active : round5Inactive
      case 5:
        return round === currentStep ? round6Active : round6Inactive

      default:
        return ''
    }
  }

  genSteps() {
    const steps = []

    for (let i = 0; i <= this.state.numSteps - 1; i++) {
      steps.push(
        <div
          style={{ width: `${100 / this.state.numSteps}%`, float: 'left' }}
          key={`internal-step${i}`}
          className={i === this.state.step ? 'active' : 'inactive'}>
          <a
            onClick={() => {
              this.setState({
                ...this.state,
                step: i
              })
            }}>
            <img
              style={{ maxHeight: '40px', maxWidth: '40px', verticalAlign: 'middle' }}
              aria-hidden="true"
              alt={t`Non-current step ${i}`}
              src={this.genImage(i, this.state.step)}
            />{' '}
            <span className="step-name">{(this.props.stepNames || [])[i]}</span>
          </a>
        </div>
      )
    }

    return steps
  }

  getSelectedChild() {
    const child = React.Children.map(this.props.children, (child, i) => {
      // Ignore the first child
      if (i === this.state.step) {
        return child
      }
    })

    return child
  }

  render() {
    return (
      <div>
        <div
          className="row step-wrapper"
          style={{
            border: '1px solid #ddd',
            borderRadius: '25px',
            backgroundColor: '#fdfdfd',
            padding: '7px',
            marginBottom: '35px'
          }}>
          {this.genSteps()}
        </div>

        {this.getSelectedChild()}

        <div className="navigation">
          <div style={{ textAlign: 'center' }}>
            <button
              className="btn btn-success"
              onClick={() => {
                if (this.state.step + 1 < this.state.numSteps) {
                  this.setState({
                    ...this.state,
                    step: this.state.step + 1
                  })
                } else {
                  this.props.onEnd()
                }
              }}>
              {this.state.step + 1 < this.state.numSteps ? t`Next` : t`Finish`}
            </button>
          </div>
        </div>
      </div>
    )
  }
}
